/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon';
// Outline
const LeroyMerlinStoreOutline = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("g", {
  stroke: "var(--i-color)",
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m7.65 8 4-4a.492.492 0 0 1 .7 0l4 4c.1.094.22.146.36.146h3.04c.28 0 .5.224.5.5v11c0 .276-.22.5-.5.5H4.25c-.28 0-.5-.224-.5-.5v-11c0-.276.22-.5.5-.5h3.04c.14 0 .26-.052.36-.146z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7.5 13.924 4.5-4.5 4.5 4.5h-9z"
}))));
// Fill
const LeroyMerlinStoreFill = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  fillRule: "evenodd",
  d: "M11.2 3.558a1.137 1.137 0 0 1 1.6 0l3.96 3.963h2.99c.62 0 1.13.504 1.13 1.125v11a1.13 1.13 0 0 1-1.13 1.125H4.25a1.13 1.13 0 0 1-1.13-1.125v-11c0-.62.51-1.125 1.13-1.125h2.99l3.96-3.963zm.36 5.424a.62.62 0 0 1 .88 0l4.5 4.5c.18.178.23.447.14.681a.636.636 0 0 1-.58.386h-9a.636.636 0 0 1-.58-.386.636.636 0 0 1 .14-.68l4.5-4.5z",
  clipRule: "evenodd"
})));
// DuoTone
const LeroyMerlinStoreDuotone = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  fillRule: "evenodd",
  d: "m11.65 4-4 4a.512.512 0 0 1-.36.146H4.25c-.28 0-.5.224-.5.5v11c0 .276.22.5.5.5h15.5c.28 0 .5-.224.5-.5v-11c0-.276-.22-.5-.5-.5h-3.04A.512.512 0 0 1 16.35 8l-4-4a.492.492 0 0 0-.7 0zM12 9.424l-4.5 4.5h9l-4.5-4.5z",
  clipRule: "evenodd",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("g", {
  stroke: "var(--i-color)",
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m7.65 8 4-4a.492.492 0 0 1 .7 0l4 4c.1.094.22.146.36.146h3.04c.28 0 .5.224.5.5v11c0 .276-.22.5-.5.5H4.25c-.28 0-.5-.224-.5-.5v-11c0-.276.22-.5.5-.5h3.04c.14 0 .26-.052.36-.146z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7.5 13.924 4.5-4.5 4.5 4.5h-9z"
}))));
/**
  Icon LeroyMerlinStoreIcon in brands group
  
  @deprecated This icon will be removed in the next major version. Date: 2024-08-15T14:15:15.647Z. Version: 0.4.2-next.0.
*/
export const LeroyMerlinStoreIcon = createIcon('LeroyMerlinStoreIcon', 'leroy-merlin-store', 'brands', LeroyMerlinStoreOutline, LeroyMerlinStoreFill, LeroyMerlinStoreDuotone, "0 0 24 24");